module.exports = __webpack_public_path__ + "static/media/DDevOps-Company-Service-Details-2021.8f32a4e6.pdf";